import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UpdateTransactionStatusPayload {
  status: string
}

export function updateTransactionStatusAction(
  transactionId: string,
  payload: UpdateTransactionStatusPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/update-status`
  return api.post<ApiResponse<unknown>>(url, { ...payload })
}

export function confirmSellerInternationalPaymentAction(transactionId: string): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/international-payment-confirmation`
  return api.post<ApiResponse<unknown>>(url)
}

export function confirmSellerIranianPaymentAction(transactionId: string): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/iranian-payment-confirmation`
  return api.post<ApiResponse<unknown>>(url)
}

export interface ConfirmBuyerBankAccountsPayload {
  iranian_source_bank_account_id: string | null
  international_bank_account_id: string | null
  international_paypal_bank_account_id: string | null
  international_revolut_bank_account_id: string | null
  international_wise_bank_account_id: string | null
}

export function confirmBuyerBankAccountsAction(
  transactionId: string,
  payload: ConfirmBuyerBankAccountsPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/requisition-owner-acceptance`
  return api.post<ApiResponse<unknown>>(url, { ...payload })
}

export interface ConfirmSellerBankAccountPayload {
  iranian_bank_account_id: string | null
}

export function confirmSellerBankAccountAction(
  transactionId: string,
  payload: ConfirmSellerBankAccountPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/offer-owner-acceptance`
  return api.post<ApiResponse<unknown>>(url, { ...payload })
}

export function buyerRejectTransactionAction(transactionId: string): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/buyer-reject-transaction`
  return api.post<ApiResponse<unknown>>(url)
}

export function sellerRejectTransactionAction(transactionId: string): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/seller-reject-transaction`
  return api.post<ApiResponse<unknown>>(url)
}
